import { Spinner, theme } from '@ketch-com/deck'
import { Box, Typography } from '@mui/material'

export interface ChartCardProps {
  title: string
  isLoading: boolean
  children?: React.ReactNode
}

export const ChartCard = ({ title, isLoading, children }: ChartCardProps) => {
  return (
    <Box
      sx={{
        background: theme.palette.Common.Container,
        maxHeight: '266px',
        width: '476px',
        borderRadius: '16px',
        padding: '16px 20px',
        flex: 1,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Box>
          <Typography variant="h4">{title}</Typography>
        </Box>
      </Box>
      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: theme.spacing(25) }}>
          <Spinner size="32px" thickness={2} />
        </Box>
      ) : (
        <Box sx={{ height: theme.spacing(25), display: 'flex', alignItems: 'center' }}>{children}</Box>
      )}
    </Box>
  )
}
